import { gql } from "graphql-tag";

import { getListOfArticles } from "~/slices/ListOfArticles/fragment";
import { getTextBlock } from "~/slices/TextBlock/fragment";
import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { getCallToAction } from "~/slices/CallToAction/fragment";
import { getNewsSubscription } from "~/slices/NewsSubscription/fragment";
import { heroBannerV2 } from "~/slices/HeroBannerV2/fragment";
import { listOfFacets } from "~/slices/ListOfFacets/fragment";
import { getListOfProducts } from "~/slices/ListOfProducts/fragment";
import { getHtmlSectionV2 } from "~/slices/HtmlSectionV2/fragment";
import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { getImageSectionV2 } from "~/slices/ImageSectionV2/fragment";

const PAGE_TYPE = "Collection_page";

const COLLECTION_PAGE_QUERY = gql`
  query collection_page($uid: String!, $lazy: Boolean!,  $lang: String = "en-in") {
    ${PAGE_TYPE}:collection_page(uid: $uid, lang: $lang) {
      collection
      title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices: body {
        ...${PAGE_TYPE}_product_catalogue_v2
        ...${PAGE_TYPE}_hero_banner_v2
        ...${PAGE_TYPE}_image_section_v2
        ...${PAGE_TYPE}_call_to_action
        ...${PAGE_TYPE}_list_of_products
        ...${PAGE_TYPE}_list_of_articles
        ...${PAGE_TYPE}_news_subscription
        ...${PAGE_TYPE}_list_of_facets
        ...${PAGE_TYPE}_text_block
        ...${PAGE_TYPE}_html_section_v2
      }
    }
  }
  ${getListOfArticles(PAGE_TYPE)}
  ${getTextBlock(PAGE_TYPE)}
  ${getProductCatalogueV2(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${getCallToAction(PAGE_TYPE)}
  ${getNewsSubscription(PAGE_TYPE)}
  ${getListOfProducts(PAGE_TYPE)}
  ${getHtmlSectionV2(PAGE_TYPE)}
  ${getImageSectionV2(PAGE_TYPE)}
  ${heroBannerV2}
  ${listOfFacets}
`;

export { COLLECTION_PAGE_QUERY, PAGE_TYPE };
